import { createReducer, on } from '@ngrx/store';
import * as BranchActions from './Branchmaster.action';

export interface BranchState {
  branches: any[];
  error: any | null;
  loading: boolean;
}

export const initialState: BranchState = {
  branches: [],
  error: null,
  loading: false,
};

export const branchReducer = createReducer(
  initialState,

  // Start fetching
  on(BranchActions.GetBranch, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  // Success
  on(BranchActions.GetBranchSuccess, (state, { GetBranchSuccess }) => ({
    ...state,
    branches: GetBranchSuccess,
    loading: false,
    error: null,
  })),

  // Failure
  on(BranchActions.GetBranchFailed, (state, { GetBranchFailed }) => ({
    ...state,
    loading: false,
    error: GetBranchFailed,
  }))
);
